import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import './style.css';
//import Forms from './form';
import CadastroME from './../../../components/Forms_ProfissionalDaSaude/Cadastro_ME';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function Title() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={1} sm={1}></Grid>
        <Grid item xs={10} sm={10}>
            <br></br>
            <br></br>
            <br></br>
            <CadastroME />
        </Grid>
      </Grid>
    </div>
  );
}
